import { Component } from 'react'
import { logReactError } from '../utils/errorLogger'

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error }
    }

    componentDidCatch(error, info) {
        logReactError(error.message, error.stack + '\n' + info.componentStack, window.location.href)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F2F4F7', padding: '20px' }}>
                    <div style={{ background: 'white', borderRadius: '16px', padding: '32px', maxWidth: '400px', width: '100%', textAlign: 'center', border: '0.5px solid #E5E7EB' }}>
                        <div style={{ fontSize: '40px', marginBottom: '16px' }}>⚠️</div>
                        <p style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: '700', color: '#1A1A1A' }}>Что-то пошло не так</p>
                        <p style={{ margin: '0 0 24px', fontSize: '14px', color: '#6B7280' }}>Ошибка зафиксирована. Попробуйте обновить страницу.</p>
                        <button onClick={() => window.location.reload()} style={{ padding: '12px 24px', background: '#0052FF', color: 'white', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
                            Обновить страницу
                        </button>
                    </div>
                </div>
            )
        }
        return this.props.children
    }
}